import { render, staticRenderFns } from "./LocationServices.vue?vue&type=template&id=4842ee4a"
import script from "./LocationServices.vue?vue&type=script&lang=js"
export * from "./LocationServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconLogo: require('/opt/atlassian/pipelines/agent/build/components/icon/IconLogo.vue').default,ServicesInstantSkipQuote: require('/opt/atlassian/pipelines/agent/build/components/services/InstantSkipQuote.vue').default,ServicesBagSizes: require('/opt/atlassian/pipelines/agent/build/components/services/BagSizes.vue').default,ServicesVanSizes: require('/opt/atlassian/pipelines/agent/build/components/services/VanSizes.vue').default,ServicesLocationStats: require('/opt/atlassian/pipelines/agent/build/components/services/LocationStats.vue').default,ServicesLocationBusinesses: require('/opt/atlassian/pipelines/agent/build/components/services/LocationBusinesses.vue').default,ServicesLocationJobs: require('/opt/atlassian/pipelines/agent/build/components/services/LocationJobs.vue').default,HomePageSection: require('/opt/atlassian/pipelines/agent/build/components/HomePageSection.vue').default})
